import React, { Component } from 'react';
import firebase from 'firebase/app'; // ← v8 호환
import { FormControl, FormGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'firebase/auth';
import 'firebase/firestore';
import './signup.css';

class Signup extends Component {
    constructor() {
        super();
        this.state = {
            email: "",
            password: ""
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        event.preventDefault();

        firebase.auth().createUserWithEmailAndPassword(this.state.email, this.state.password)
            .then((authData) => {
                console.log('createUserWithEmailAndPassword is called : ', authData);

                // Initialize Cloud Firestore through Firebase
                const db = firebase.firestore();

                // Add user profile document with user ID
                db.collection("profiles").doc(authData.user.uid).set({
                    email: authData.user.email,
                    author: authData.user.uid,
                })
                .then(() => console.log("created profiles data"))
                .catch(error => console.error("Error adding profiles document: ", error));
            })
            .catch(error => {
                console.log('createUserWithEmailAndPassword error : ', error.code, error.message);
            });
    };

    render() {
        return(
            <div className="signup-container">
                <div className="row">
                    <div className="col-sm-4 col-sm-offset-4">
                        <form onSubmit={this.handleSubmit}>
                            <FormGroup controlId="email">
                                <FormControl
                                    type="text"
                                    value={this.state.email}
                                    placeholder="email"
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup controlId="password">
                                <FormControl
                                    type="password"
                                    value={this.state.password}
                                    placeholder="password"
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <div className="submit-buttons">
                                <button type="submit" className="btn btn-success">Sign Up</button>
                            </div>
                        </form>
                        <div className="info">
                            <div className="text-center">
                                Already have an account? <Link to='/login'>Log in</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Signup;


// WEBPACK FOOTER //
// ./src/component/signup/signup.js